
import { changeLocale } from '@/utils/Locale';
import { env } from "@/env";
import { Component } from 'vue-property-decorator';
import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';
import { namespace } from 'vuex-class/lib/bindings';
import router from '@/router';
import moment from 'moment';
import ComponentBase from '@/mixins/componentBase';

const userIdentityStore = namespace('userIdentity');

@Component({
  name: 'RepsolLayoutLoginComponent',
})
class RepsolLayoutLoginComponent extends ComponentBase {
  environment = env.environment;

  private ssoAccessToken: string | null = null;

  @userIdentityStore.Action
  public fetchLoginPingOne!: (payload: any) => Promise<any>;

  public languages = [...env.topLanguages!.split(',')];
  setLanguage(language: string) {
    changeLocale(language, true)
  }

  mounted(){
    console.log("Cfg", env);
    const token = this.getOAuthHashParam('id_token');

    if (!token) return;

    this.ssoAccessToken = token;
    history.pushState({}, '', this.$route.path);

    this.openSpinner("login.cargando");
    this.loginWithPingOne(token);
  }

  private getOAuthHashParam(key: string): string | null {
    const hash = this.$route?.hash;
    if (!hash) return null;

    const params = new URLSearchParams(hash.startsWith('#') ? hash.substring(1) : hash);
    const value = params.get(key);
    return value || null;
  }

  async loginWithPingOne(token:string): Promise<void>{
    try {
      (store.state as any).loader.isLoading = true;

      const userIdentity: UserIdentityModel | false = await this.fetchLoginPingOne({
        token,
      });
      console.log("userIdentity", userIdentity);
      if (userIdentity && !!userIdentity.token) {
        router.push('/operaciones/presentes_futuras?q-fechaDesde='+ moment(new Date()).format("YYYY-MM-DD"));
      }

      (store.state as any).loader.isLoading = false;
    } catch (error: any) {
      const messageError = 'response_error.login';
      this.$toast.error(this.$t(messageError));
      (store.state as any).loader.isLoading = false;
    }
  }

  private getRedirectUri(): string {
    return env.auth.redirectUri;
  }

  public LoadPingOne(): void {
    const redirectUri = this.getRedirectUri();
    window.location.replace(`${env.auth.authority}?client_id=${encodeURIComponent(env.auth.clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(env.auth.consentScopes)}&response_type=${encodeURIComponent(env.auth.responseType)}`)
    // window.history.pushState({}, '', searchURL.t;oString());
  }
}

export default RepsolLayoutLoginComponent;
